import { useQuery } from 'react-query';
import sortBy from 'lodash.sortby';
import { fetchCompanies } from '@general/api/companyAPI';

const sampleCompanyList = [
    { name: 'Foster Made', id: 671526 },
    { name: 'Rappaport', id: 3131 },
    { name: 'Apple', id: 1 },
    { name: 'Meta', id: 2 },
    { name: 'Netflix', id: 3 },
];

const useCompaniesFromApi = () => {
    // const { data, ...rest } = useQuery(
    //     `companies`,
    //     async () => {
    //         const response = await fetchCompanies();
    //         return response?.data?.data || null;
    //     },
    //     {
    //         staleTime: Infinity,
    //     }
    // );
    // return { companies: sampleCompanyList, ...rest };

    // NOTE: When we switch this over to an actual API call, I would return the data as is,
    //       and then format it downstream. This will make this hook more reusable.
    const formattedCompanies =
        // data &&
        sortBy(
            sampleCompanyList.map(({ id, name }) => {
                return { label: name, value: id.toString() };
            }),
            'label'
        );

    return { companies: formattedCompanies };
};

export default useCompaniesFromApi;
